import { InsertDriveFileOutlined } from '@mui/icons-material';
import { Button } from '@mui/material';
import shadows from '@mui/material/styles/shadows';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { darkerBackground, darkGrey, darkRed, primaryBlue } from '../models/colors';
import type { ITableHeaderFields } from '../pages/homepage';

const TableContainer = styled('div')`
	overflow-x: auto;
	box-shadow: ${shadows[1]};
`;

const Table = styled('table')`
	width: 100%;
	min-width: 720px;
	border-spacing: 0;
	flex-direction: column;
	border-collapse: collapse;
`;
const TableBody = styled('tbody')``;
const TableRowBase = styled('tr')`
	width: 100%;
	height: 48px;
	justify-content: space-between;
	& > * {
		padding: 6px;
	}
`;
const TableRowHeader = styled(TableRowBase as any)`
	background-color: ${primaryBlue};
`;
const TableRow = styled(TableRowBase)`
	&:nth-child(odd) {
		background-color: ${darkerBackground};
	}
`;
const TableHeader = styled('th')`
	color: #ffffff;
	text-align: left;
	font-weight: bold;
	&:first-child {
		padding-left: 10px;
	}
	&:last-child {
		text-align: right;
		padding-right: 10px;
	}
`;
const TableCell = styled('td')`
	&:last-child {
		text-align: right;
		font-weight: bold;
		padding-right: 10px;
		font-size: 0.875rem;
	}
	&[data-tag='1'] {
		color: ${primaryBlue};
	}
	&[data-tag='3'] {
		color: ${darkGrey};
	}
	&[data-tag='0'] {
		color: ${darkRed};
	}
`;
const ViewAgreement = styled(({ label, onClick, ...rest }: any) => (
	<Button
		variant={`text`}
		sx={{
			padding: '4px',
			fontWeight: 'bold',
			fontSize: '0.8125rem',
			textTransform: 'none',
			color: primaryBlue,
		}}
		{...rest}
		onClick={onClick}
	>
		<InsertDriveFileOutlined />
		{label}
	</Button>
))`
	&:hover {
		text-decoration: underline;
	}
`;

const status = ['Expired', 'Active', 'In Progress', 'Signed', 'Cancelled'];

export const AgreementsTable = ({ data, headers }: any) => {
	const navigate = useNavigate();

	return (
		<TableContainer>
			<Table>
				<TableBody>
					<TableRowHeader>
						{headers.map((v: ITableHeaderFields, idx: number) => (
							<TableHeader title={v.title} key={idx}>
								{v.label}
							</TableHeader>
						))}
					</TableRowHeader>
					{data.map((v: any, idx: number) => (
						<TableRow key={idx}>
							<TableCell>
								<ViewAgreement
									label={v.status === 2 ? 'Sign Agreement' : 'View Agreement'}
									onClick={() =>
										v.status === 2
											? navigate(`/agreement/sign`, {
													state: { fleetCompanyId: v.fleetCompanyId },
												})
											: navigate(`/agreement/view?id=${v.id}`)
									}
								/>
							</TableCell>
							<TableCell>{v.tsp}</TableCell>
							<TableCell>{v.signedDate && format(new Date(v.signedDate), 'yyyy/MM/dd p')}</TableCell>
							<TableCell>{v.signedDate && format(new Date(v.expirationDate), 'yyyy/MM/dd p')}</TableCell>
							<TableCell data-tag={v.status}>{status[v.status].toUpperCase()}</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
};
